import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { ToastrService } from "ngx-toastr";
import { EMPTY, Observable, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';
import { TranslationService, ErrorMessageExtractor } from "@cloud-and-service/portal-lib";
import { MainState } from "@cloud-and-service/portal-lib";
import { AuthService } from "@cloud-and-service/portal-lib";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
        private store: Store,
        private toastrService: ToastrService,
        private translation: TranslationService,
        private errorExtractor: ErrorMessageExtractor
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((err: any) => {

            if ([401, 403].includes(err.status)) {
                if (this.store.selectSnapshot(MainState.auth)) {
                    this.authService.logout();
                    return EMPTY;
                }
            }

            if ([429].includes(err.status)) {
                this.toastrService.warning(this.translation.getTranslation('BACK_OFF'));
            }

            // Handle network errors (offline, no connection)
            if (err.status === 0 || err instanceof ProgressEvent) {
                return throwError(() => this.translation.getTranslation('NETWORK_ERROR'));
            }

            const error = this.errorExtractor.extractErrorMessage(err);
            const translatedError = this.errorExtractor.translateErrorCode(error);
            return throwError(() => translatedError);
        }));
    }
}
